module.exports = __webpack_public_path__ + "img/intranet.52aada31.png";